import { useEffect, useState } from "react";
import useAppMain from "src/hooks/useAppMain";
import { CLIENT_TAB_LIST, PATH_NAMES } from "src/utils/constants";
import { Box, Flex, useMantineTheme, Button, Skeleton } from "@mantine/core";
import { useNavigate, useParams } from "react-router-dom";
import {
  SignedAgreementStatus,
  useGetEmbeddedLinkQuery,
  useGetSignedAgreementDocumentsQuery,
  useSignDocumentMutation,
} from "src/generated/graphql";
import { useAppContext } from "src/api/AppContext";

function AgreementDocument() {
  const theme = useMantineTheme();
  const cardBg = theme.colors.primary[4];
  const { currentClient } = useAppContext();
  const [enableBtn, setenableBtn] = useState(false);
  const navigate = useNavigate();
  const { signedAgreementId = "" } = useParams();
  useAppMain(CLIENT_TAB_LIST.AGREEMENT_OVERVIEW, true);

  const { loading, data: signedAgreementDetail } =
    useGetSignedAgreementDocumentsQuery({
      variables: {
        id: signedAgreementId,
      },
      skip: !signedAgreementId,
      fetchPolicy: "network-only",
      onCompleted(data) {
        if (
          data.signedAgreementOne?.status ===
          SignedAgreementStatus.NoPaymentMethod
        ) {
          setenableBtn(true);
        }
      },
    });

  useEffect(() => {
    function handleMessage(event: MessageEvent) {
      if (
        event.origin === window.location.origin &&
        event.data.documentSigned
      ) {
        handleSubmit();
      }
    }
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [signedAgreementDetail]);

  const [signDoc, { loading: signingDocLoading }] = useSignDocumentMutation({});

  const { data: link } = useGetEmbeddedLinkQuery({
    variables: { signedAgreementId },
    skip: !signedAgreementId,
    fetchPolicy: "network-only",
  });

  const handleSubmit = async () => {
    const { status, signedDocGroup } =
      signedAgreementDetail?.signedAgreementOne || {};
    if (signingDocLoading || !signedDocGroup?.id) return;
    // if signed agreement is UnSigned then signDocument else just navigate
    if (status === SignedAgreementStatus.Unsigned) {
      await signDoc({
        variables: {
          signDocumentId: signedDocGroup!.id,
          data: {
            signee: { id: currentClient!.id },
          },
        },
      });

      handleContinue();
    } else {
      handleContinue();
    }
  };

  const handleContinue = () => {
    navigate(`/${PATH_NAMES.AGREEMENT_CHECKOUT}/${signedAgreementId}`);
  };

  if (loading) return <Skeleton w="100%" height={80} />;
  return (
    <Flex
      direction={"column"}
      justify={"space-between"}
      sx={{ height: "100%" }}
    >
      <Box bg={cardBg}>
        <iframe
          src={link?.getEmbeddedLink || ""}
          height="auto"
          width="100%"
          frameBorder={0}
          style={{ minHeight: "70vh" }}
        ></iframe>
      </Box>

      <Button
        disabled={!signedAgreementDetail?.signedAgreementOne?.id && enableBtn}
        onClick={handleSubmit}
      >
        Continue to Payment
      </Button>
    </Flex>
  );
}

export default AgreementDocument;
